export const PRIMARY = '#480ca8';
export const SECONDARY = '#4361ee';
export const GREEN = '#abad5a';
//export const GREEN = '#98EC6F';abad5a
export const RED = '#fec52d';
//export const RED = '#f8636b';
export const ORANGE = '#fcba73';
export const THEMEBLUE = '#6395fa';
export const THEMEGREEN = '#63daab';
export const THEMEPURPLE = '#7666fa';
